import { LogDTO } from './../../models/logDTO';
import { LogService } from './../../services/log/log.service';
import { FunctionsService } from './../../services/common/functions.service';
import { ENTIDADE } from './../../config/entidade.config';
import { CandidatoService } from './../../services/candidato/candidato.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-log',
  templateUrl: './log.component.html',
  styleUrls: ['./log.component.scss'],
})
export class LogComponent implements OnInit {

  idEntidade: number;
  entidade: string;

  idEntidade2: number;
  entidade2: string;

  logs: LogDTO[] = [];

  constructor( private logService: LogService
             , private functionsService: FunctionsService ) { 

  }

  ngOnInit() {}


  ionViewWillEnter(){
   
    this.functionsService.presentLoading();

    this.logService.findByEntidadeAndId(this.entidade, this.idEntidade).subscribe({
      next:(resp)=>{ 

        this.logs = resp;

        if(this.entidade2 && this.idEntidade2){

          this.logService.findByEntidadeAndId(this.entidade2, this.idEntidade2).subscribe({
            next:(resp2)=>{
  
              if(!this.logs){
                this.logs = [];
              }
              this.logs.push(...resp2);
  
              this.functionsService.dismissLoading();
  
            },
            error:(error2)=>{
              console.log(error2);
              this.functionsService.dismissLoading();
            }
          });

        }else{
          this.functionsService.dismissLoading();
        }
        
        

      },
      error:(error)=>{
        console.log(error);
        this.functionsService.dismissLoading();

      }
    });
  }
}
